import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { fmtMoney } from "@/lib/api";
import { PageHeader } from "@/components/shared/PageHeader";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid } from "recharts";

const COLORS = ["#3DBB2C", "#3B82F6"];

export default function StoreAnalytics() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/store/${slug}/analytics`).then((r) => setD(r.data)).catch(() => {}); }, [slug]);
  if (!d) return <div className="text-slate-400">Chargement…</div>;

  return (
    <div>
      <PageHeader title="Analyse" subtitle="Performances, produits, canaux et rentabilité" />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="vp-card rounded-xl p-6">
          <h3 className="text-lg font-semibold text-white mb-4">Canaux de vente</h3>
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie data={d.channels} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={90} label={(e) => e.name}>
                {d.channels.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip formatter={(v) => fmtMoney(v)} contentStyle={{ background: "#14161D", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, color: "#fff" }} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="vp-card rounded-xl p-6">
          <h3 className="text-lg font-semibold text-white mb-4">Meilleures ventes</h3>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={d.best_sellers} layout="vertical" margin={{ left: 20 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
              <XAxis type="number" stroke="#64748b" fontSize={11} />
              <YAxis type="category" dataKey="name" stroke="#64748b" fontSize={10} width={110} />
              <Tooltip contentStyle={{ background: "#14161D", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, color: "#fff" }} />
              <Bar dataKey="qty" fill="#3DBB2C" radius={[0, 4, 4, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="vp-card rounded-xl p-6 mt-6">
        <h3 className="text-lg font-semibold text-white mb-4">Rentabilité par produit</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {d.best_sellers.map((p, i) => (
            <div key={i} className="bg-black/20 rounded-lg p-4">
              <div className="text-sm text-white line-clamp-1">{p.name}</div>
              <div className="text-xs text-slate-500 mt-1">Qté vendue: <span className="mono">{p.qty}</span></div>
              <div className="mono vp-accent-text mt-1">{fmtMoney(p.revenue)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
